//import { users } from "@/api/mock_users";
import { mapGetters } from "vuex";
import apiService from "../../api/api.service";
import rules from "../../utils/rules";
import countryPhoneCodes from "../../utils/countryPhoneCodes.json";
import app from "../../utils/app.json";
import InfoDialog from "@/components/InfoDialog";
import pageheader from "../pageheader";
import utils from "../../utils/util";
import telematicsService from "../../api/telematics.service";
import smsService from "./../../api/reservePlan.service";
import smsServiceNew from "./../../api/reservePlanNew.service";

// Full permission list shown to Admin / Birch User. Returns a fresh array on
// every call because callers mutate the result (push/splice/filter). The Birch
// User variant is identical minus the "Admin" entry.
const buildFullNavItems = (includeAdmin = true) => {
  const items = [
    "Overview",
    "Map",
    "On Rent Equipment",
    "Birch Fleet",
    "Customer Owned Equipment",
    "Contracts",
    "Service & Maintenance",
    "Reserve & Order",
    "Alerts Management",
    "Reports",
    "View All Reports",
    "Utilization Report - Detailed",
    "Existing Active Alerts",
    "On Rent",
    "On Reservation",
    "Overdue",
    "New Operational",
    "Trip",
    "Incident",
    "Activity",
    "Actual Spend To Date",
    "Off Rent",
    "SMS On Rent",
    "On Rent With Spend Analysis",
    "Planned Vs Actual",
    "Rent To Date And Projected",
    "Active Maintenance",
    "Historical Maintenance",
    "Customer Balance",
    "SMS Alerts",
    "Settings",
    "Access Control Codes",
    "Access Control",
    "Admin",
    "Service Call",
    "Utilization",
  ];
  return includeAdmin ? items : items.filter((e) => e != "Admin");
};

// Report sub-menu entries. Spread (never mutated in place) so it is safe to
// reuse as the source for both the data() seed and the toggle handlers.
const REPORTS_SUBMENU_ITEMS = [
  "Utilization Report - Detailed",
  "Existing Active Alerts",
  "On Rent",
  "On Reservation",
  "Overdue",
  "New Operational",
  "Trip",
  "Incident",
  "Activity",
  "Actual Spend To Date",
  "Off Rent",
  "SMS On Rent",
  "On Rent With Spend Analysis",
  "Planned Vs Actual",
  "Rent To Date And Projected",
  "Active Maintenance",
  "Historical Maintenance",
  "Customer Balance",
  "Service Call",
  "Utilization",
];

// Maps each planning-sheet checkbox label to its settings key, in checkbox order.
const PLANNING_SHEET_MAP = [
  { label: "Create Planning Sheets", key: "createPlanningSheets" },
  { label: "Approve Planning Sheets", key: "approvePlanningSheets" },
  { label: "Submit Planning Sheets", key: "submitPlanningSheets" },
  { label: "Delete Planning Sheets", key: "deletePlanningSheets" },
  { label: "See Rates on Planning Sheets", key: "seeRatesOnPlanningSheets" },
  { label: "Use Market Rates", key: "useMarketRates" },
  { label: "Call Equipment Off Rent", key: "callEquipmentOffRent" },
];

export default {
  name: "user-management",
  components: { InfoDialog, pageheader },
  props: [],
  data() {
    return {
      isloading: false,
      userProfileDetails: {},
      selectAllPlanningSheet: false,
      planningSheetSettings: {
        createPlanningSheets: false,
        approvePlanningSheets: false,
        submitPlanningSheets: false,
        deletePlanningSheets: false,
        seeRatesOnPlanningSheets: false,
        useMarketRates: false,
        callEquipmentOffRent: false,
      },
      selectedData: [],
      checkboxesdata: [
        "Create Planning Sheets",
        "Approve Planning Sheets",
        "Submit Planning Sheets",
        "Delete Planning Sheets",
        "See Rates on Planning Sheets",
        "Use Market Rates",
        "Call Equipment Off Rent",
      ],
      isloadingJobsites: false,
      isloadingJobNum: false,
      isloadingPoNum: false,
      isloadingOrderNum: false,
      isloadingPickedNum: false,
      countryPhoneCodes,
      twoFactorAuth: true,
      phoneCountryCode: "1",
      cellCountryCode: "1",
      phoneCountryName: "us",
      cellCountryName: "us",
      shiftSearchFilter: "",

      defaultShiftOptions: [
        // { name: "Standard", value: 0 },
        { name: "Standby", value: 0 },
        { name: "Single", value: 1 },
        { name: "Double", value: 2 },
        { name: "Triple", value: 3 },
      ],
      user: {
        isValid: true,
        role: "",
      },
      selectedJobNum: null,
      selectedJobSite: null,
      selectedPONum: null,
      selectedOrderBy: null,
      selectedPickedUpby: null,
      isDisplayInfoDialog: false,
      valid: true,
      editing: false,
      rules: rules,
      role: [],
      authRole: "",
      provider: "Standard",
      customerList: [],
      customerIDs: [],
      jobNum: [
      ],
      jobSiteArr: [
      ],
      POArr: [
      ],
      OrderByArr: [
      ],
      PickedUpByArr: [
      ],
      confirmPasswordRules: [
        (value) => !!value || "Confirm password is required",
        (value) =>
          value === this.user.password ||
          "The password confirmation does not match.",
      ],
      formType: "",
      loading: false,
      input: {},
      isLoaderCust: false,
      searchCustomer: null,
      birchContacts: [],
      selectedBirchContact: "",
      searchBirchContact: "",
      SMSUserTypeList: [
        { name: "Admin", value: "A" },
        { name: "Approver", value: "P" },
        { name: "Birch User", value: "B" },
        { name: "Standard", value: "U" },
      ],
      selectedSMSUserType: "",
      searchSMSUserType: "",
      smsCustomersList: [],
      selectedSMSCustomer: {},
      searchSMScustomer: "",
      isLoaderBirchContact: false,
      showSMSFilters: false,
      navItems: buildFullNavItems(),
      navItemsMaster: [
        "Overview",
        "On Rent Equipment",
        "Birch Fleet",
        "Customer Owned Equipment",
        "Contracts",
        "Service & Maintenance",
        "Reserve & Order",
        "Alerts Management",
        "Reports",
      ],
      reportsSubmenu: [...REPORTS_SUBMENU_ITEMS],
      otherNavItemsMaster: [
        "SMS Alerts",
        "Settings",
        "Access Control",
        "Access Control Codes",
      ],
      selectAllReports: false,
      isSMSUserLoad: false,
    };
  },
  watch: {
    "$route.query.type": {
      handler: function (type) {
        this.formType = type;
      },
    },
    searchCustomer(val) {
      // Items have already been loaded
      //if (this.parentCompaniesList.length > 1) return;

      // Items have already been requested
      //if (this.isLoaderCust) return;

      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 2 == 0) {
        this.searchCustomers(val);
      }
    },
  },
  created() {
    if ("id" in this.$route.params) {
      this.getUserById();
      this.editing = true;
    } else {
      this.clearForm();
    }

    if (this.editing == false) {
      this.navItems = buildFullNavItems();
      this.selectAllReports = true;
    }
    //comment existing active alerts logic

    this.applyRoleNavFilters(true);
    this.getBasicCustomers();
  },
  computed: {
    ...mapGetters(["roles", "basicCustomers", "companyIdDropdown"]),
    // ...mapGetters(["roles", "basicCustomers", "permissions"]),
  },
  mounted() {
    this.input = utils.getInputContent("usermanagement", this.roles);
    if (this.roles == "Admin" || this.roles == "Birch User") {
      this.authRole = app.userRoles;
    } else if (this.roles == "Customer") {
      this.authRole = app.userRoles.filter(
        (x) => x != "Admin" && x != "Birch User"
      );
    }
    if (this.formType == "") {
      this.clearForm();
    }
    this.getBirchContact();
    this.getSMSCustomer();
    this.applyRoleNavFilters(true);
  },
  methods: {
    // Trims role-restricted entries from the nav/report menus. Customer role
    // drops the restricted items; Admin/Birch/empty re-inserts "Existing Active
    // Alerts". includeBirchFleet also strips "Birch Fleet" (used by the pre-save
    // / load paths, not by the report-toggle handlers).
    applyRoleNavFilters(includeBirchFleet) {
      if (this.user.role == "Customer") {
        this.navItems = this.navItems.filter(
          (e) => e != "Existing Active Alerts"
        );
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Existing Active Alerts"
        );
        if (includeBirchFleet) {
          this.navItems = this.navItems.filter((e) => e != "Birch Fleet");
          this.navItemsMaster = this.navItemsMaster.filter(
            (e) => e != "Birch Fleet"
          );
          this.reportsSubmenu = this.reportsSubmenu.filter(
            (e) => e != "Birch Fleet"
          );
        }
        this.navItems = this.navItems.filter((e) => e != "SMS On Rent");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "SMS On Rent"
        );
        this.navItems = this.navItems.filter((e) => e != "Service Call");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Service Call"
        );
        this.navItems = this.navItems.filter((e) => e != "Active Maintenance");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Active Maintenance"
        );
        this.reportsSubmenu = [...new Set(this.reportsSubmenu)];
        this.navItems = [...new Set(this.navItems)];
      } else if (
        this.user.role == "Admin" ||
        this.user.role == "Birch User" ||
        this.user.role == "" ||
        this.user.role == null
      ) {
        this.reportsSubmenu.splice(1, 0, "Existing Active Alerts");
        this.navItems.splice(1, 0, "Existing Active Alerts");
        this.reportsSubmenu = [...new Set(this.reportsSubmenu)];
        this.navItems = [...new Set(this.navItems)];
      }
    },
    handlePlanningSheet() {
      PLANNING_SHEET_MAP.forEach(({ label, key }) => {
        this.planningSheetSettings[key] = this.selectedData.includes(label);
      });
      this.selectAllPlanningSheet = this.selectedData.length == 7;
    },
    onSelectPhone({ iso2, dialCode }) {
      this.phoneCountryCode = dialCode;
      this.phoneCountryName = iso2;
    },
    onSelectOffice({ iso2, dialCode }) {
      this.cellCountryCode = dialCode;
      this.cellCountryName = iso2;
    },
    remove(item) {
      this.jobSiteArr = this.jobSiteArr.filter(
        (e) => e.jobsiteid != item.jobsiteid
      );
      this.selectedJobSite = this.selectedJobSite.filter(
        (e) => e.jobsiteid != item.jobsiteid
      );
    },
    remove1(item) {
      this.jobNum = this.jobNum.filter((e) => e.jobNumname != item.jobNumname);
      this.selectedJobNum = this.selectedJobNum.filter(
        (e) => e.jobNumname != item.jobNumname
      );
    },
    remove2(item) {
      this.POArr = this.POArr.filter((e) => e.poname != item.poname);
      this.selectedPONum = this.selectedPONum.filter(
        (e) => e.poname != item.poname
      );
    },
    remove3(item) {
      this.OrderByArr = this.OrderByArr.filter((e) => e.oname != item.oname);
      this.selectedOrderBy = this.selectedOrderBy.filter(
        (e) => e.oname != item.oname
      );
    },
    remove4(item) {
      this.PickedUpByArr = this.PickedUpByArr.filter(
        (e) => e.pname != item.pname
      );
      this.selectedPickedUpby = this.selectedPickedUpby.filter(
        (e) => e.pname != item.pname
      );
    },
    getUniqueListBy(arr, key) {
      // For removing duplicates based on serialNumber
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    changeselected() {
      if (this.selectedJobSite != null && this.selectedJobSite.length != 0) {
        this.selectedJobSite = this.selectedJobSite.filter((e) => e != null);
      } else {
        this.selectedJobSite = null;
      }
      if (this.selectedJobNum != null && this.selectedJobNum.length != 0) {
        this.selectedJobNum = this.selectedJobNum.filter((e) => e != null);
      } else {
        this.selectedJobNum = null;
      }
      if (this.selectedPONum != null && this.selectedPONum.length != 0) {
        this.selectedPONum = this.selectedPONum.filter((e) => e != null);
      } else {
        this.selectedPONum = null;
      }
      if (this.selectedOrderBy != null && this.selectedOrderBy.length != 0) {
        this.selectedOrderBy = this.selectedOrderBy.filter((e) => e != null);
      } else {
        this.selectedOrderBy = null;
      }
      if (
        this.selectedPickedUpby != null &&
        this.selectedPickedUpby.length != 0
      ) {
        this.selectedPickedUpby = this.selectedPickedUpby.filter(
          (e) => e != null
        );
      } else {
        this.selectedPickedUpby = null;
      }
    },
    openInfoDialog() {
      this.isDisplayInfoDialog = true;
    },
    changerole() {
      if (this.user.role == "Customer") {
        this.user.customer = null;
        this.navItems = this.navItems.filter((e) => e != "Birch Fleet");
        this.navItemsMaster = this.navItemsMaster.filter(
          (e) => e != "Birch Fleet"
        );
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Birch Fleet"
        );
      }
      if ((this.user.role == null) | (this.user.role == "")) {
        (this.planningSheetSettings = {
          createPlanningSheets: false,
          approvePlanningSheets: false,
          submitPlanningSheets: false,
          deletePlanningSheets: false,
          seeRatesOnPlanningSheets: false,
          useMarketRates: false,
          callEquipmentOffRent: false,
        }),
          (this.selectedData = []);
      }
      if (this.user.role == "Admin") {
        this.selectAllPlanningSheet = true;
        (this.planningSheetSettings = {
          createPlanningSheets: true,
          approvePlanningSheets: true,
          submitPlanningSheets: true,
          deletePlanningSheets: true,
          seeRatesOnPlanningSheets: true,
          useMarketRates: true,
          callEquipmentOffRent: true,
        }),
          (this.selectedData = [
            "Create Planning Sheets",
            "Approve Planning Sheets",
            "Submit Planning Sheets",
            "Delete Planning Sheets",
            "See Rates on Planning Sheets",
            "Use Market Rates",
            "Call Equipment Off Rent",
          ]);
      }
      if (this.user.role == "Customer") {
        this.selectAllPlanningSheet = false;

        (this.planningSheetSettings = {
          createPlanningSheets: true,
          approvePlanningSheets: false,
          submitPlanningSheets: true,
          deletePlanningSheets: true,
          seeRatesOnPlanningSheets: true,
          useMarketRates: false,
          callEquipmentOffRent: true,
        }),
          (this.selectedData = [
            "Create Planning Sheets",
            // "Approve Planning Sheets",
            "Submit Planning Sheets",
            "Delete Planning Sheets",
            "See Rates on Planning Sheets",
            "Use Market Rates",
            "Call Equipment Off Rent",
          ]);
      }
      if (this.user.role == "Birch User") {
        this.selectAllPlanningSheet = true;

        (this.planningSheetSettings = {
          createPlanningSheets: true,
          approvePlanningSheets: true,
          submitPlanningSheets: true,
          deletePlanningSheets: true,
          seeRatesOnPlanningSheets: true,
          useMarketRates: true,
          callEquipmentOffRent: true,
        }),
          (this.selectedData = [
            "Create Planning Sheets",
            "Approve Planning Sheets",
            "Submit Planning Sheets",
            "Delete Planning Sheets",
            "See Rates on Planning Sheets",
            "Use Market Rates",
            "Call Equipment Off Rent",
          ]);
      }
      // if (this.user.role == "Approver") {
      //   this.selectAllPlanningSheet = false;

      if (this.editing) {
        let reportCheckAll = this.reportsSubmenu.every((elem) =>
          this.navItems.includes(elem)
        );
        if (reportCheckAll) {
          this.selectAllReports = true;
        } else {
          this.selectAllReports = false;
        }
      }

      this.applyRoleNavFilters(true);
    },
    changeCust() {
      if (
        this.user.customer == undefined ||
        (this.user.customer && this.user.customer.length == 0)
      ) {
        this.selectedJobSite = null;
        this.selectedJobNum = null;
        this.jobSiteArr = [];
        this.jobNum = [];
        // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        // this.jobNum.unshift({ name: "All" ,jobnumid: null});
      } else {
        this.getJobsitesSmsId();
        this.getJobNumSmsId();
        this.getPOSmsId();
        this.getOrderSmsId();
        this.getPickedSmsId();
      }
      this.applyRoleNavFilters(false);
    },
    removeCustomer(item) {
      if (item.id != 7620 || item.id != 5704) {
        this.navItems = this.navItems.filter(
          (e) => e != "Existing Active Alerts"
        );
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Existing Active Alerts"
        );
        this.reportsSubmenu = [...new Set(this.reportsSubmenu)];

        this.navItems = this.navItems.filter((e) => e != "SMS On Rent");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "SMS On Rent"
        );
        this.navItems = this.navItems.filter((e) => e != "Service Call");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Service Call"
        );
        this.navItems = this.navItems.filter((e) => e != "Active Maintenance");
        this.reportsSubmenu = this.reportsSubmenu.filter(
          (e) => e != "Active Maintenance"
        );
        this.navItems = [...new Set(this.navItems)];
      }
      let cNum = item.smsCustomerId;
      this.user.customer = this.user.customer.filter(
        (e) => e.name != item.name
      );
      if (cNum != "") {
        if (this.selectedJobSite != null) {
          this.selectedJobSite = this.selectedJobSite.filter(
            (e) => e.name != item.name
          );
          this.jobSiteArr = this.jobSiteArr.filter((e) => e.name != item.name);
        }
      }
      if (this.selectedJobNum != null) {
        this.selectedJobNum = this.selectedJobNum.filter(
          (e) => String(e.name) != String(item.name)
        );
        this.jobNum = this.jobNum.filter(
          (e) => String(e.name) != String(item.name)
        );
      }
      if (this.selectedPONum != null) {
        this.selectedPONum = this.selectedPONum.filter(
          (e) => String(e.name) != String(item.name)
        );
        this.POArr = this.POArr.filter(
          (e) => String(e.name) != String(item.name)
        );
      }

      if (this.selectedOrderBy != null) {
        this.selectedOrderBy = this.selectedOrderBy.filter(
          (e) => String(e.name) != String(item.name)
        );
        this.OrderByArr = this.OrderByArr.filter(
          (e) => String(e.name) != String(item.name)
        );
      }
      if (this.selectedPickedUpby != null) {
        this.selectedPickedUpby = this.selectedPickedUpby.filter(
          (e) => String(e.name) != String(item.name)
        );
        this.PickedUpByArr = this.PickedUpByArr.filter(
          (e) => String(e.name) != String(item.name)
        );
      }
    },
    handleReportsToggle() {
      if (this.navItems.includes("Reports")) {
        this.navItems.push(...REPORTS_SUBMENU_ITEMS);
        this.selectAllReports = true;
      } else {
        this.navItems = this.navItems.filter(
          (val) => !this.reportsSubmenu.includes(val)
        );
        this.selectAllReports = false;
        // console.log(
        //   this.navItems.filter((val) => !this.reportsSubmenu.includes(val))
        // );
      }
      if (!this.selectAllReports) {
        this.navItems = this.navItems.filter((e) => e != "Reports");
      }
      this.applyRoleNavFilters(false);
    },
    handleAllReportsToggle() {
      if (this.selectAllReports) {
        this.navItems.push("Reports", ...REPORTS_SUBMENU_ITEMS);
        this.navItems = [...new Set(this.navItems)];
      } else {
        this.navItems = this.navItems.filter(
          (val) => !this.reportsSubmenu.includes(val) && val != "Reports"
        );
        this.navItems = [...new Set(this.navItems)];
      }
      this.applyRoleNavFilters(false);
    },
    handleAllSettings() {
      if (this.selectAllPlanningSheet == true) {
        PLANNING_SHEET_MAP.forEach(({ label, key }) => {
          this.planningSheetSettings[key] = true;
          this.selectedData.push(label);
        });
        this.selectedData = [...new Set(this.selectedData)];
      } else {
        this.planningSheetSettings = {
          createPlanningSheets: false,
          approvePlanningSheets: false,
          submitPlanningSheets: false,
          deletePlanningSheets: false,
          seeRatesOnPlanningSheets: false,
          useMarketRates: false,
          callEquipmentOffRent: false,
        };
        this.selectedData = [];
      }
    },
    handleSomeReports() {
      let reportCheck = this.navItems.some((elem) =>
        this.reportsSubmenu.includes(elem)
      );

      if (reportCheck) {
        if (!this.navItems.includes("Reports")) this.navItems.push("Reports");
      } else {
        this.navItems = this.navItems.filter((e) => e != "Reports");
      }
      let reportCheckAll = this.reportsSubmenu.every((elem) =>
        this.navItems.includes(elem)
      );
      if (reportCheckAll) {
        this.selectAllReports = true;
      } else {
        this.selectAllReports = false;
      }
      this.applyRoleNavFilters(false);
    },

    handleMainMenu() {
      if (this.navItems.includes("Contracts")) {
        if (!this.navItems.includes("Map")) this.navItems.push("Map");
      }
      if (this.navItems.includes("On Rent Equipment")) {
        if (!this.navItems.includes("Map")) this.navItems.push("Map");
      }
      if (this.navItems.includes("Map")) {
        if (!this.navItems.includes("Customer Owned Equipment"))
          this.navItems.push("Customer Owned Equipment");
      }

      if (!this.navItems.includes("Customer Owned Equipment")) {
        this.navItems = this.navItems.filter(
          (e) => e != "Customer Owned Equipment"
        );
      }
    },
    async searchCustomers(value) {
      try {
        this.isLoaderCust = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.customerList = finaldata;
          this.isLoaderCust = false;
        } else {
          this.isLoaderCust = false;
        }
      } catch (err) {
        this.isLoaderCust = false;
        console.log(err);
      }
    },
    getBasicCustomers() {
      this.customerList = this.basicCustomers.filter(
        (item) => item.name != "All"
      );
    },
    openModal() {
      this.$refs.modal.showModal();
    },
    async getUserById() {
      try {
        this.isloading = true;
        let response = await apiService.getUserById(this.$route.params.id);
        if (response.data) {
          this.isloading = false;

          this.user = response.data;
          this.user.shift = Number(response.data.shift);
          this.userProfileDetails = response.data.userProfileDetails;
          this.planningSheetSettings =
            response.data.userProfileDetails.planningSheetSettings;
          PLANNING_SHEET_MAP.forEach(({ label, key }) => {
            if (this.planningSheetSettings[key] == true) {
              this.selectedData.push(label);
            }
          });
          this.selectedData = [...new Set(this.selectedData)];

          if (this.selectedData.length == 7) {
            this.selectAllPlanningSheet = true;
          } else {
            this.selectAllPlanningSheet = false;
          }
          this.user.userName = response.data.email;
          this.twoFactorAuth = response.data.twoFactorEnabled;
          this.phoneCountryCode = response.data.phoneCountryCode;
          this.cellCountryCode = response.data.cellCountryCode;
          this.phoneCountryName = response.data.phoneCountryName;
          this.cellCountryName = response.data.cellCountryName;
          this.user.customer = response.data.customers;
          this.customerList = response.data.customers;
          this.selectedJobNum =
            this.user.jobNos != null && this.user.jobNos != ""
              ? JSON.parse(this.user.jobNos)
              : null;
          this.selectedJobSite =
            this.user.jobSites != null && this.user.jobSites != ""
              ? JSON.parse(this.user.jobSites)
              : null;
          this.selectedPONum =
            this.user.poNos != null && this.user.poNos != ""
              ? JSON.parse(this.user.poNos)
              : null;
          this.selectedOrderBy =
            this.user.orderBy != null && this.user.orderBy != ""
              ? JSON.parse(this.user.orderBy)
              : null;
          this.selectedPickedUpby =
            this.user.pickedUpBy != null && this.user.pickedUpBy != ""
              ? JSON.parse(this.user.pickedUpBy)
              : null;

          this.applyRoleNavFilters(true);
          if (
            this.user.customer == undefined ||
            (this.user.customer && this.user.customer.length == 0)
          ) {
            // no action needed when no customer is selected
          } else {
            this.getJobsitesSmsIdById();
            this.getJobNumSmsIdById();
            this.getPOSmsIdById();
            this.getOrderSmsIdById();
            this.getPickedIdById();
          }

          //   // this.getJobsitesSmsId();
          // }
          if (
            response.data.smsUserId != null &&
            response.data.smsUserId != ""
          ) {
            this.selectedSMSCustomer.BirchCustomerUserID =
              response.data.smsUserId;
            this.showSMSFilters = true;
          } else {
            this.showSMSFilters = false;
          }
          if (this.user.role != "Admin" && this.user.role != "Birch User") {
            this.navItems = [];
            this.navItems =
              response.data.permissions != null
                ? response.data.permissions.split(",")
                : ["Map"];
            if (this.navItems.includes("View All Reports")) {
              this.navItems = this.navItems.filter(
                (e) => e != "View All Reports"
              );
            }
            let reportCheckAll = this.reportsSubmenu.every((elem) =>
              this.navItems.includes(elem)
            );
            if (reportCheckAll) {
              this.selectAllReports = true;
            }

            // this.handleAllReportsInternal();
          } else if (this.user.role == "Admin") {
            this.navItems = [];
            this.navItems = buildFullNavItems(true);
          } else if (this.user.role == "Birch User") {
            this.navItems = [];
            this.navItems = buildFullNavItems(false);
          }
        } else {
          this.isloading = false;
          this.user = {};
        }
        this.formType = "edit";
      } catch (err) {
        this.loading = false;
        console.log("error", err);
      }
    },
    async getJobsitesSmsIdById() {
      let custarry = this.user.customer;

      for (var i = 0; i < custarry.length; i++) {
        this.isloadingJobsites = true;
        let response = await smsServiceNew.getJobsiteListUserPage(
          custarry[i].id
        );
        if (response.data) {
          this.isloadingJobsites = false;
          let data23 = response.data.map((d) => {
            return {
              name: custarry[i].name,
              cNum: d.cNum,
              jobsiteid: d.number,
              description: d.description,
            };
          });

          this.jobSiteArr = this.jobSiteArr.concat(data23);

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
          this.jobSiteArr = this.getUniqueListBy(
            this.jobSiteArr,
            "description"
          );
        } else {
          this.isloadingJobsites = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      }
    },

    async getJobsitesSmsId() {
      this.isloadingJobsites = true;
      let userCustomerIDsa = [];
      let usernames = [];
      let usernamesArr = "";

      if (this.user && this.user.customer) {
        this.user.customer.map((item) => {
          userCustomerIDsa.push(item.id);

          usernames.push(item.name);
        });

        if (usernames != []) {
          usernamesArr = usernames.join(",");
        } else {
          usernamesArr = "";
        }
      }

      if (usernamesArr != "") {
        // let recentId = userCustomerIDsa[userCustomerIDsa.length - 1];
        let recentId = userCustomerIDsa.join(",");

        // let recentName = usernames[usernames.length - 1];

        let response = await smsServiceNew.getJobsiteListUserPage(recentId);
        if (response.data) {
          this.isloadingJobsites = false;
          let data23 = response.data.map((d) => {
            return {
              name: d.customerName,
              jobsiteid: d.number,
              description: d.description,
            };
          });

          this.jobSiteArr = this.jobSiteArr.concat(data23);

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
          this.jobSiteArr = this.getUniqueListBy(
            this.jobSiteArr,
            "description"
          );
        } else {
          this.isloadingJobsites = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      } else {
        this.isloadingJobsites = false;
        this.selectedJobSite = null;
        this.jobSiteArr = [];
        // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
      }
    },

    async getJobNumSmsId() {
      this.isloadingJobNum = true;
      let userCustomerIDsab = [];
      let userCustomerIDsArr1 = "";
      let usernames = [];
      if (this.user && this.user.customer) {
        this.user.customer.map((item) => {
          userCustomerIDsab.push(item.id);
          usernames.push(item.name);
        });
        if (userCustomerIDsab != []) {
          userCustomerIDsArr1 = userCustomerIDsab.join(",");
        } else {
          userCustomerIDsArr1 = "";
        }
      }

      if (userCustomerIDsArr1 != "") {
        let recentId = userCustomerIDsab.join(",");
        // let recentName = usernames[usernames.length - 1];

        let response = await smsServiceNew.getAvailableJobNoRestrictions(
          recentId
        );
        if (response.data) {
          this.isloadingJobNum = false;
          //  let data1=response;
          let data = response.data.map((d) => {
            return {
              name: d.customerName,
              jobNumname: d.jobNo,
              jobnumid: d.jobNoValue,
            };
          });

          this.jobNum = this.jobNum.concat(data);

          let fdata = this.getUniqueListBy(this.jobNum, "jobNumname");
          this.jobNum = fdata;
        } else {
          this.isloadingJobNum = false;
          // this.selectedJobSite=null;

          // this.jobNum.unshift({ name: "All" ,jobnumid: null});
        }
      } else {
        this.isloadingJobNum = false;
        this.selectedJobNum = null;
        this.jobNum = [];
        // this.jobNum.unshift({ name: "All" ,jobnumid: null});
      }
    },
    async getJobNumSmsIdById() {
      let custarry = this.user.customer;

      for (var i = 0; i < custarry.length; i++) {
        this.isloadingJobNum = true;
        let response = await smsServiceNew.getAvailableJobNoRestrictions(
          custarry[i].id
        );
        if (response.data) {
          this.isloadingJobNum = false;

          let data23 = response.data.map((d) => {
            return {
              name: d.customerName,
              jobNumname: d.jobNo,
              jobnumid: d.jobNoValue,
            };
          });

          // this.jobNum = data23;
          this.jobNum = this.jobNum.concat(data23);
        } else {
          this.isloadingJobNum = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      }
    },
    async getPOSmsId() {
      this.isloadingPoNum = true;
      let userCustomerIDsab = [];
      let userCustomerIDsArr1 = "";
      let usernames = [];
      if (this.user && this.user.customer) {
        this.user.customer.map((item) => {
          userCustomerIDsab.push(item.id);
          usernames.push(item.name);
        });
        if (userCustomerIDsab != []) {
          userCustomerIDsArr1 = userCustomerIDsab.join(",");
        } else {
          userCustomerIDsArr1 = "";
        }
      }

      if (userCustomerIDsArr1 != "") {
        // let recentId = userCustomerIDsab[userCustomerIDsab.length - 1];
        let recentId = userCustomerIDsab.join(",");

        // let recentName = usernames[usernames.length - 1];

        let response = await smsServiceNew.getAvailablePONoRestrictions(
          recentId
        );
        if (response.data) {
          this.isloadingPoNum = false;
          //  let data1=response;
          let data = response.data.map((d) => {
            return {
              name: d.customerName,
              poname: d.poNo,
              ponumid: d.poNoValue,
            };
          });

          this.POArr = this.POArr.concat(data);

          let fdata = this.getUniqueListBy(this.POArr, "poname");
          this.POArr = fdata;
        } else {
          this.isloadingPoNum = false;
          // this.selectedJobSite=null;

          // this.jobNum.unshift({ name: "All" ,jobnumid: null});
        }
      } else {
        this.isloadingPoNum = false;
        this.selectedPONum = null;
        this.POArr = [];
        // this.jobNum.unshift({ name: "All" ,jobnumid: null});
      }
    },
    async getPOSmsIdById() {
      let custarry = this.user.customer;

      for (var i = 0; i < custarry.length; i++) {
        this.isloadingPoNum = true;
        let response = await smsServiceNew.getAvailablePONoRestrictions(
          custarry[i].id
        );
        if (response.data) {
          this.isloadingPoNum = false;

          let data23 = response.data.map((d) => {
            return {
              name: d.customerName,
              poname: d.poNo,
              ponumid: d.poNoValue,
            };
          });

          // this.POArr = data23;
          this.POArr = this.POArr.concat(data23);

          let fdata = this.getUniqueListBy(this.POArr, "poname");
          this.POArr = fdata;
        } else {
          this.isloadingPoNum = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      }
    },

    async getPickedSmsId() {
      this.isloadingPickedNum = true;
      let userCustomerIDsab = [];
      let userCustomerIDsArr1 = "";
      let usernames = [];
      if (this.user && this.user.customer) {
        this.user.customer.map((item) => {
          userCustomerIDsab.push(item.id);
          usernames.push(item.name);
        });
        if (userCustomerIDsab != []) {
          userCustomerIDsArr1 = userCustomerIDsab.join(",");
        } else {
          userCustomerIDsArr1 = "";
        }
      }

      if (userCustomerIDsArr1 != "") {
        // let recentId = userCustomerIDsab[userCustomerIDsab.length - 1];
        let recentId = userCustomerIDsab.join(",");

        // let recentName = usernames[usernames.length - 1];

        let response = await smsServiceNew.getAvailablePickedUpByRestrictions(
          recentId
        );
        if (response.data) {
          this.isloadingPickedNum = false;
          //  let data1=response;
          let data = response.data.map((d) => {
            return {
              name: d.customerName,
              pname: d.pickedUpBy,
              pnumid: d.pickedUpByValue,
            };
          });

          this.PickedUpByArr = this.PickedUpByArr.concat(data);

          let fdata = this.getUniqueListBy(this.PickedUpByArr, "pname");
          this.PickedUpByArr = fdata;
        } else {
          this.isloadingPickedNum = false;
          // this.selectedJobSite=null;

          // this.jobNum.unshift({ name: "All" ,jobnumid: null});
        }
      } else {
        this.isloadingPickedNum = false;
        this.selectedPONum = null;
        this.PickedUpByArr = [];
        // this.jobNum.unshift({ name: "All" ,jobnumid: null});
      }
    },
    async getPickedIdById() {
      let custarry = this.user.customer;

      for (var i = 0; i < custarry.length; i++) {
        this.isloadingPickedNum = true;
        let response = await smsServiceNew.getAvailablePickedUpByRestrictions(
          custarry[i].id
        );
        if (response.data) {
          this.isloadingPickedNum = false;

          let data23 = response.data.map((d) => {
            return {
              name: d.customerName,
              pname: d.pickedUpBy,
              pnumid: d.pickedUpByValue,
            };
          });

          this.PickedUpByArr = this.PickedUpByArr.concat(data23);
        } else {
          this.isloadingPickedNum = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      }
    },

    async getOrderSmsId() {
      this.isloadingOrderNum = true;
      let userCustomerIDsab = [];
      let userCustomerIDsArr1 = "";
      let usernames = [];
      if (this.user && this.user.customer) {
        this.user.customer.map((item) => {
          userCustomerIDsab.push(item.id);
          usernames.push(item.name);
        });
        if (userCustomerIDsab != []) {
          userCustomerIDsArr1 = userCustomerIDsab.join(",");
        } else {
          userCustomerIDsArr1 = "";
        }
      }

      if (userCustomerIDsArr1 != "") {
        let recentId = userCustomerIDsab[userCustomerIDsab.length - 1];
        // let recentName = usernames[usernames.length - 1];

        let response = await smsServiceNew.getAvailableOrderedByRestrictions(
          recentId
        );
        if (response.data) {
          this.isloadingOrderNum = false;
          //  let data1=response;
          let data = response.data.map((d) => {
            return {
              name: d.customerName,
              oname: d.orderBy,
              onumid: d.orderByValue,
            };
          });

          this.OrderByArr = this.OrderByArr.concat(data);

          let fdata = this.getUniqueListBy(this.OrderByArr, "oname");
          this.OrderByArr = fdata;
        } else {
          this.isloadingOrderNum = false;
          // this.selectedJobSite=null;

          // this.jobNum.unshift({ name: "All" ,jobnumid: null});
        }
      } else {
        this.isloadingOrderNum = false;
        this.selectedPONum = null;
        this.OrderByArr = [];
        // this.jobNum.unshift({ name: "All" ,jobnumid: null});
      }
    },
    async getOrderSmsIdById() {
      let custarry = this.user.customer;

      for (var i = 0; i < custarry.length; i++) {
        this.isloadingOrderNum = true;
        let response = await smsServiceNew.getAvailableOrderedByRestrictions(
          custarry[i].id
        );
        if (response.data) {
          this.isloadingOrderNum = false;

          let data23 = response.data.map((d) => {
            return {
              name: d.customerName,
              oname: d.orderBy,
              onumid: d.orderByValue,
            };
          });

          this.OrderByArr = this.OrderByArr.concat(data23);
        } else {
          this.isloadingOrderNum = false;
          // this.selectedJobSite=null;

          // this.jobSiteArr.unshift({ description: "All" ,jobsiteid: null});
        }
      }
    },
    validateForm() {
      let isFormValid = false;
      if (
        this.user.role === "Customer" &&
        (this.user.customer == undefined ||
          (this.user.customer && this.user.customer.length == 0))
      ) {
        this.$toast.error("Please select atleast one customer");
      } else {
        isFormValid = true;
      }

      return isFormValid;
    },
    async userSave() {
      if (this.$refs.form.validate() && this.validateForm()) {
        this.loading = true;
        let userCustomerIDs = [];
        if (this.user && this.user.customer) {
          this.user.customer.map((item) => {
            userCustomerIDs.push(item.id);
          });
        }
        if (this.user.role != "Admin" && this.user.role != "Birch User") {
          // this.navItems = [];
          this.navItems = this.navItems != null ? this.navItems : ["Map"];
          if (this.navItems.includes("Reports")) {
            this.navItems.push("View All Reports");
          }
        } else if (this.user.role == "Admin") {
          this.navItems = [];
          this.navItems = buildFullNavItems(true);
        } else if (this.user.role == "Birch User") {
          this.navItems = [];
          this.navItems = buildFullNavItems(false);
        }

        this.applyRoleNavFilters(true);
        let navdata = [...this.navItems].concat("Logout");
        //removing the mask formatting from the phone number models
        let userPhoneNumber = this.user.phoneNumber.replace(/\D+/g, "");
        let userOfficePhone = this.user.officePhone.replace(/\D+/g, "");
        let payload = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          phoneCountryCode: this.phoneCountryCode,
          phoneNumber: userPhoneNumber,
          phoneCountryName: this.phoneCountryName,
          cellCountryCode: this.cellCountryCode,
          cellCountryName: this.cellCountryName,
          officePhone: userOfficePhone,
          twoFactorEnabled: this.twoFactorAuth,
          userName: this.user.userName,
          // customers:this.user.customer? customerdata: this.user.customer,
          role: this.user.role,
          customerIds: userCustomerIDs.map(String),
          smsOrderBy: "",
          smsPickedUpBy: "",
          shift: "",
          deliveryRequired: false,
          smsUserType: this.selectedSMSCustomer?.CustomerStatusID,
          smsCustomerId: this.selectedSMSCustomer?.BirchCustomerID,
          smsContactId: this.selectedSMSCustomer?.BirchCustomerUserID,
          jobNos:
            this.selectedJobNum != null && this.selectedJobNum != ""
              ? JSON.stringify(this.selectedJobNum)
              : null,
          jobSites:
            this.selectedJobSite != null && this.selectedJobSite != ""
              ? JSON.stringify(this.selectedJobSite)
              : null,
          poNos:
            this.selectedPONum != null && this.selectedPONum != ""
              ? JSON.stringify(this.selectedPONum)
              : null,
          orderBy:
            this.selectedOrderBy != null && this.selectedOrderBy != ""
              ? JSON.stringify(this.selectedOrderBy)
              : null,
          pickedUpBy:
            this.selectedPickedUpby != null && this.selectedPickedUpby != ""
              ? JSON.stringify(this.selectedPickedUpby)
              : null,
          permissions:
            this.user.role == "Customer" ? [...new Set(navdata)] : null,
          planningSheetSettingsDto: this.planningSheetSettings,
        };

        try {
          var apiResponse;
          if (this.$route.query.type == "edit") {
            apiResponse = await apiService.updateUser(
              this.$route.params.id,
              payload
            );
          } else {
            // (payload.officePhone = this.user.officePhone),
            let payloaduser = {
              name: this.user.firstName + " " + this.user.lastName,
              email: this.user.userName,
              phone: userPhoneNumber,
              mobile: userPhoneNumber,
              planningSheetSettingsDto: this.planningSheetSettings,
            };
            payload.provider = this.provider;
            payload.password = this.user.password;

            apiResponse = await apiService.createUser(payload);

            let customerarr = [];

            let telematicresponse;
            if (this.user.role == "Customer") {
              customerarr = this.user.customer.map((e) => e.id);
              for (var i = 0; i < customerarr.length; i++) {
                telematicresponse =
                  await telematicsService.CreateAlarmBatteryContacts(
                    customerarr[i],
                    payloaduser
                  );
              }
            } else if (
              customerarr.length == 0 ||
              this.user.role == "Admin" ||
              this.user.role == "Birch User" ||
              this.user.role == "" ||
              this.user.role == null
            ) {
              telematicresponse =
                await telematicsService.CreateAlarmBatteryContacts(
                  null,
                  payloaduser
                );
            }
            if (telematicresponse) {
              // no action needed
            }
          }

          if (apiResponse) {
            this.loading = false;
            if (apiResponse.isSuccess) {
              this.$refs.form.reset();
              this.$toast.success(apiResponse.systemMessage);
              if (
                this.$route.query.from == "FromCustomer" &&
                this.$route.query.CustomerDetailsId != ""
              ) {
                if (this.$route.query && this.$route.query.isFilter) {
                  this.$router.push(
                    `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
                  );
                } else {
                  this.$router.push(
                    `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
                  );
                }
              } else {
                this.$router.push({
                  path: "/user-management/list",
                });
              }
              if (this.showSMSFilters) {
                this.$store.dispatch("setShowSMSLeftNav", true);
              }
            } else {
              this.loading = false;
              this.$toast.error(apiResponse.systemMessage);
            }
          }
        } catch (err) {
          this.loading = false;
          this.$toast.error("Unable to create user" + err);
        }
      }
    },
    reset() {
      this.$refs.form.reset();
      if (
        this.$route.query.from == "FromCustomer" &&
        this.$route.query.CustomerDetailsId != ""
      ) {
        if (this.$route.query && this.$route.query.isFilter) {
          this.$router.push(
            `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
          );
        } else {
          this.$router.push(
            `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
          );
        }
      } else {
        this.$router.push({
          path: "/user-management/list",
        });
      }
    },
    clearForm() {
      this.user = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        officePhone: "",
        userName: "",
        password: "",
        provider: this.provider,
        role: "",
      };
    },
    async getBirchContact() {
      this.isLoaderBirchContact = true;
      try {
        let response = await smsService.smsBirchContacts();
        if (response.data) {
          let birchContactsList = response.data.map((item) => {
            return {
              fName: item.CustomerUserNameFirst
                ? item.CustomerUserNameFirst
                : "",
              lName: item.CustomerUserNameLast ? item.CustomerUserNameLast : "",
              id: item.BirchCustomerUserID ? item.BirchCustomerUserID : "",
              contactName: "",
            };
          });
          this.birchContacts = birchContactsList.map((item) => {
            return {
              contactName: item.fName + " " + item.lName,
              id: item.id,
            };
          });
          this.birchContacts.sort(function (a, b) {
            if (a.contactName < b.contactName) {
              return -1;
            }
            if (a.contactName > b.contactName) {
              return 1;
            }
            return 0;
          });
          this.isLoaderBirchContact = false;
        } else {
          this.birchContacts = [];
          this.isLoaderBirchContact = false;
        }
      } catch (err) {
        this.isLoaderBirchContact = false;
        console.log(err);
      }
    },
    async getSMSCustomer() {
      this.isSMSUserLoad = true;
      try {
        let response = await smsService.getcustomer();
        if (response) {
          let result = response.flatMap(
            ({ CustomerName, BirchCustomerUsers }) =>
              BirchCustomerUsers.map((s) => ({
                CustomerName: CustomerName,
                ...s,
              }))
          );
          result.map((item) => {
            if (item.CustomerStatusID == "A") {
              item.userRole = "(Admin)";
            } else if (item.CustomerStatusID == "B") {
              item.userRole = "(Birch User)";
            } else if (item.CustomerStatusID == "P") {
              item.userRole = "(Approver)";
            } else {
              item.userRole = "(Standard)";
            }
          });
          result.map((item) => {
            if (item.CustomerName) {
              item.CustomerName = "(" + item.CustomerName.trim() + ")";
            }
          });
          let tempSMSList = result.filter((e) => e.CustomerUserActiveID == "A");
          let tempSMSListFiltered = tempSMSList.map(function (element) {
            return {
              CustomerUserNameFirst: element.CustomerUserNameFirst
                ? element.CustomerUserNameFirst + " "
                : "",
              CustomerUserNameLast: element.CustomerUserNameLast
                ? element.CustomerUserNameLast + " "
                : "",
              userRole: element.userRole ? element.userRole + " " : "",
              CustomerName: element.CustomerName ? element.CustomerName : "",
              BirchCustomerUserID: element.BirchCustomerUserID
                ? element.BirchCustomerUserID
                : "",
              CustomerStatusID: element.CustomerStatusID
                ? element.CustomerStatusID
                : "",
              BirchCustomerID: element.BirchCustomerID
                ? element.BirchCustomerID
                : "",
            };
          });
          this.smsCustomersList = tempSMSListFiltered.map(function (element) {
            return {
              cName:
                element.CustomerUserNameFirst +
                element.CustomerUserNameLast +
                element.userRole +
                element.CustomerName,
              BirchCustomerUserID: element.BirchCustomerUserID
                ? element.BirchCustomerUserID
                : "",
              CustomerStatusID: element.CustomerStatusID
                ? element.CustomerStatusID
                : "",
              BirchCustomerID: element.BirchCustomerID
                ? element.BirchCustomerID
                : "",
            };
          });
          this.isSMSUserLoad = false;
        } else {
          this.smsCustomersList = [];
          this.isSMSUserLoad = false;
        }
      } catch (err) {
        this.isSMSUserLoad = false;
        console.log(err);
      }
    },
    onboardSMSUserChange() {
      if (this.showSMSFilters == false) {
        this.selectedBirchContact = "";
        this.selectedSMSCustomer = "";
        this.selectedSMSUserType = "";
      }
    },
    ClearSMSUserType() {
      this.selectedSMSUserType = "";
    },
    ClearSMSBirchContact() {
      this.selectedBirchContact = "";
    },
    ClearSMSCustomer() {
      this.selectedSMSCustomer = {};
    },
    updateRouterParams() {
      if (
        this.$route.query.from == "FromCustomer" &&
        this.$route.query.CustomerDetailsId != ""
      ) {
        if (this.$route.query && this.$route.query.isFilter) {
          this.$router.push(
            `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
          );
        } else {
          this.$router.push(
            `/view-customer-details/${this.$route.query.CustomerDetailsId}?search=${this.$route.query.SearchCust}&isFilter=${this.$route.query.isFilter}`
          );
        }
      } else {
        this.$router.push(
          `/user-management/list?filterVal=${this.$route.query.filterVal}&isFilter=${this.$route.query.isFilter}`
        );
      }
    },
    async onReloadCustomers() {
      try {
        this.isLoaderCust = true;
        let response = await telematicsService.updateReloadCustomers();
        if (response.isSuccess) {
          setTimeout(() => {
            this.customerList = response.data;
            this.isLoaderCust = false;
            //update the reloaded customers to the store
            this.$store.dispatch("setReloadedBasicCustomers", response.data);
            this.$toast.success("Customers loaded successfully");
          }, 5000);
        }
      } catch (err) {
        this.isLoaderCust = false;
        this.customerList = [];
      }
    },
  },
};
